import { CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CURRENCY_HNL, CURRENCY_USD, CardType, PersonalLoanType } from 'src/app/@core/constants';
import { AddPaymentModalService } from 'src/app/@core/services/add-payment-modal.service';
import { CalculationUtils } from 'src/app/@core/utils/calculation-utils';
import { ColumnTable } from 'src/app/models/column-table';
import { DoPaymentParamEmitter } from 'src/app/models/do-payment-param-emitter';
import { ExchangeRate } from 'src/app/models/exchange-rate';
import { Paging } from 'src/app/models/page';
import { Payment } from 'src/app/models/payment';
import { PaymentMethod } from 'src/app/models/payment-method';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { ExchangeRateService } from 'src/app/services/exchange-rate.service';
import { ParamsService } from 'src/app/services/params.service';
import { PaymentTypesService } from 'src/app/services/payment-types.service';
@Component({
  selector: 'app-pos-payment-method',
  templateUrl: './pos-payment-method.component.html',
  styleUrls: ['./pos-payment-method.component.sass']
})
export class PosPaymentMethodComponent implements OnInit, OnDestroy {

  @Input() totalAmount = 1000;
  @Input() contractAmount = 0;
  @Output() doPayment = new EventEmitter<DoPaymentParamEmitter>();
  @Input() disablePaymentButton: boolean = false;
  @Input() id: string = '';
  @Input() customerCode: string = "";
  directPaymentMethods: Array<PaymentMethod> = [];
  otherPaymentMethods: Array<PaymentMethod> = [];
  otherPayment: PaymentMethod;

  paymentList: Paging<Array<PaymentMethod>> = new Paging([]);
  restCashPayment = 0;
  validatedPayments: Array<Payment> = [];
  exchangeRate = 0;
  paymentsAmount = 0;
  contractPayment = new PaymentMethod();
  latestExchangeRate: ExchangeRate = new ExchangeRate();
  private readonly CASH_CODE = "ZE01";
  private readonly CONTRACT_CODE = "CT";
  private readonly DIRECT_PAYMENTS_COUNT = 9;
  private readonly MULTIDESCRIPTION = 'MULTIDESCRIPTION';
  private readonly USD = "USD";

  @Input() isForRecollection = false;
  @Input() isQuotaAmountValid = true;

  constructor(
    private paymentService: PaymentTypesService,
    private addPaymentModalService: AddPaymentModalService,
    private configurationService: ConfigurationService,
    private route: ActivatedRoute,
    private exchangeRateService: ExchangeRateService,
    private currencyPipe: CurrencyPipe,
    private paramsService: ParamsService,
    private readonly exceptionSolutionService: ExceptionSolutionService) {
    this.otherPayment = new PaymentMethod();
  }

  ngOnDestroy(): void {
    this.doPayment.emit({ id: "", payments: [], paymentsAmount: 0, totalAmount: 0 });
  }

  async ngOnInit(): Promise<void> {
    await this.getPaymentMethods();
    this.latestExchangeRate = await this.exchangeRateService.readLatestExchangeRate();
    this.exchangeRate = this.latestExchangeRate.rate;
    if (this.contractAmount) {
      this.paymentList.content.push(this.contractPayment);
      this.calculateRest();
    }
  }

  public setAmountContract() {

  }

  private async getPaymentMethods(): Promise<void> {

    const salesOrgObject = this.configurationService.readSelectedBranchAndSalesOrg().salesOrg;
    const salesOrg = salesOrgObject.code;

    let paymentMethods = (await this.paymentService.getPaymentsType().toPromise()).response.content;
    paymentMethods = paymentMethods.sort((a, b) => a.position > b.position ? 1 : -1);

    //let paymenTypesAvailable = param != undefined ? param.value.split(',') : [];
    // let paymenTypesAvailable: Array<string> = [];


    if (this.contractAmount) {
      const index = paymentMethods.findIndex(element => element.code === this.CONTRACT_CODE);
      if (index !== -1) {
        this.contractPayment = paymentMethods[index];
        this.contractPayment.amount = this.contractAmount;
        this.contractPayment.applied = this.contractAmount;
        this.contractPayment.paymentMethodCode = "ZC01";
      }
    }
    paymentMethods.forEach(f => {
      f.personalLoanType = PersonalLoanType.CASH;
      f.cardType = CardType.AMEX;
    })
    // paymentMethods = paymentMethods.filter(p => paymenTypesAvailable.some(ptl => ptl == p.code));
    let paymentMethodTypes = (await this.paymentService.getPaymentMethods(salesOrg).toPromise()).response.content;

    paymentMethodTypes.forEach(type => {
      const index = paymentMethods.findIndex(element => element.code === type.paymentTypeCode);
      if (index !== -1) {
        const paymentMethod = paymentMethods[index];
        if (paymentMethod.style === this.MULTIDESCRIPTION && type.bankAccounts[salesOrg]) {
          type.name += ` ${type.bankAccounts[salesOrg]}`;
        }

        if (paymentMethod.methods?.length) {
          paymentMethod.methods.push(type);
        } else {
          paymentMethod.methods = [type];
        }
      }
    });

    this.directPaymentMethods = paymentMethods.slice(0, this.DIRECT_PAYMENTS_COUNT);
    this.otherPaymentMethods = paymentMethods.slice(this.DIRECT_PAYMENTS_COUNT)
      .filter(element => element.code !== 'AP' && element.code !== 'PAC' && element.code !== 'CT');
  }

  async addPayment(payment: PaymentMethod): Promise<void> {
    this.otherPayment = new PaymentMethod();
    if (payment.methods == undefined) {
      this.exceptionSolutionService.showAlertWithSolution('Tipo de pago sin metodo asociado', 'Este tipo de pago no tiene metodo asociado');
      return;
    }
    const pm = new PaymentMethod();
    Object.assign(pm, payment);
    await this.addPaymentModalService.show(pm, this.totalAmount, this.paymentsAmount, this.customerCode, this.paymentList.content, 0,
      () => {
        this.calculateRest();
      });
  }

  pay(): void {
    const payments = this.paymentList.content.map(paymentMethod => {
      const payment = new Payment();
      payment.amount = paymentMethod.currency == CURRENCY_USD ? paymentMethod.usdAmount : paymentMethod.amount;
      payment.bankName = paymentMethod.bank;
      payment.currency = paymentMethod.currency;
      payment.paymentMethodCode = paymentMethod.paymentMethodCode;
      payment.receiptNumber = paymentMethod.identifier ?? "";
      payment.number = paymentMethod.number ?? "";
      payment.name = paymentMethod.personName ?? "";
      payment.cardType = paymentMethod.cardType;
      payment.personalLoanType = paymentMethod.personalLoanType;
      payment.personalLoanTerm = paymentMethod.personalLoanTerm;
      if (paymentMethod.currency != CURRENCY_HNL) {
        payment.exchangeRate = this.latestExchangeRate;
      }
      return payment;
    });

    if (this.restCashPayment > 0) {
      const paymentRest: Payment = new Payment();
      paymentRest.amount = -this.restCashPayment.toFixed(2);
      paymentRest.currency = CURRENCY_HNL;
      paymentRest.paymentMethodCode = this.CASH_CODE;
      payments.push(paymentRest);
    }

    console.log(payments);
    this.validatedPayments = payments;
    this.doPayment.emit({ payments, paymentsAmount: this.paymentsAmount, id: this.id, totalAmount: this.totalAmount });
  }

  calculateRest(): void {
    let amount = 0;
    this.paymentsAmount = 0;

    this.paymentList.content.forEach(payment => {
      if (payment.code === this.CASH_CODE) {
        const finalAmount = this.round(this.totalAmount - (this.paymentsAmount + Number(payment.amount ?? 0)));
        let rest = 0;

        if (finalAmount < 0) {
          rest = -finalAmount;
          amount = this.round(amount + rest);
        }

        payment.applied = this.round(Number(payment.amount ?? 0) - rest);
        this.paymentsAmount += Number(payment.amount ?? 0);
      } else if (payment.currency === this.USD) {
        if (!payment.usdAmount) {
          payment.usdAmount = Number(payment.amount ?? 0);
        }
        const resultChange = this.round(payment.usdAmount * this.exchangeRate);
        const finalAmount = this.round(this.totalAmount - (this.paymentsAmount + resultChange));
        let rest = 0;

        if (finalAmount < 0) {
          rest = -finalAmount;
          amount = this.round(amount + rest);
        }
        payment.amount = resultChange;
        payment.exchangeRate = this.exchangeRate;

        const appliedAmountUSD = this.round((resultChange - rest) / this.exchangeRate);
        payment.applied = appliedAmountUSD;
        this.paymentsAmount += resultChange;
      } else {
        this.paymentsAmount += Number(payment.amount ?? 0);
      }
    });

    this.restCashPayment = amount;
    this.parseAmountsToShow();
    if (this.disablePaymentButton) {
      this.pay();
    }
  }

  parseAmountsToShow(): void {
    this.paymentList.content.forEach(payment => {
      if (payment.currency === this.USD) {
        payment.amountToShow = this.currencyPipe.transform(this.round(payment.amount / payment.exchangeRate), CURRENCY_USD, 'code', '1.0-2') ?? "";
        const usdAmount = this.currencyPipe.transform(payment.applied, CURRENCY_USD, 'code', '1.0-2') ?? "";
        const appliedHnl = this.round(payment.applied * payment.exchangeRate);
        payment.appliedToShow = `${usdAmount} (${appliedHnl})`;
      } else {
        payment.amountToShow = this.currencyPipe.transform(payment.amount, CURRENCY_HNL, 'code', '1.0-2') ?? "";
        payment.appliedToShow = this.currencyPipe.transform(payment.applied, CURRENCY_HNL, 'code', '1.0-2') ?? "";
      }
    });
  }

  removePaymentMethod(method: PaymentMethod): void {
    if (method.code != this.CONTRACT_CODE) {
      const index = this.paymentList.content.findIndex(payment => payment.code == method.code && (payment.identifier ?? "") == method.identifier);
      if (index !== -1) {
        const payment = this.paymentList.content[index];
        payment.amount = 0;
        payment.amountToShow = '';
        payment.applied = 0;
        payment.appliedToShow = '';
        payment.usdAmount = 0;
        this.paymentList.content.splice(index, 1);
        this.calculateRest();
      }
    }
  }

  getPaymentHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable('name', 'Tipo Pago'),
      new ColumnTable('amountToShow', 'Total'),
      new ColumnTable('appliedToShow', 'Aplicado'),
      new ColumnTable('identifier', 'Identificador'),
      new ColumnTable('code', 'Opciones', {
        type: 'action', actions: [
          {
            fn: (payment) => this.removePaymentMethod(payment),
            icon: 'fa fa-times text-danger',
            tooltip: "Eliminar pago",
            isDisabled: false,
          }
        ],
        iconClass: "fa fa-cogs",
        isIcon: true
      }),
    ];
  }

  private round(amount: number): number {
    return CalculationUtils.round(amount);
  }

}
